import {
  IBaseTransferDetails,
  ITray,
  ITransferDetailsData,
} from '../../../types';

interface IFormatTransferDetailsParam {
  data: ITransferDetailsData;
  isConvertToTransferDetails?: boolean;
  isTrays: boolean;
}

/**
 * Formatter for transfer details response
 * @param data ITransferDetailsData
 * @param isConvertToTransferDetails boolean
 * @returns IBaseTransferDetails or ITransferDetailsData
 */
export function formatTransferDetailsResponse({
  data,
  isConvertToTransferDetails = false,
  isTrays = false,
}: IFormatTransferDetailsParam): ITransferDetailsData | null {
  if (!data) return null;

  let scannedData: IBaseTransferDetails | null = null;
  let formattedTrays: ITray[] = [];
  const { trays } = data || {};

  if (isTrays && trays && trays.length > 0) {
    formattedTrays = trays.map(
      ({ trayId, tray, quantity, trayOperationalStatus }) => ({
        trayId,
        trayNumber: tray,
        appraisalCount: quantity.toString(),
        transferStatus: trayOperationalStatus,
      })
    );
  }

  if (isConvertToTransferDetails) {
    const {
      inventoryTransferId,
      inventoryTransferStatus,
      sourcePod,
      sourceTrayId,
      sourceTrayNumber,
      sourceZone,
      destinationPod,
      destinationZone,
      sourceWorkStationId,
      destinationWorkStationId,
      destinationWorkStationName,
      destinationIsCommonStation,
      totalInventories,
      noOfTrays,
    } = data;

    // Set title based on tray and destination scan status
    const isTray = !!sourceTrayNumber;
    const openTransferTitle = isTray
      ? `${sourceTrayNumber}, ${sourcePod}`
      : `All Trays in ${sourcePod}`;
    const isDestinationScanned = inventoryTransferStatus === 'IN_PROGRESS';
    const title = isDestinationScanned
      ? destinationWorkStationName
      : openTransferTitle;
    const barcode = isDestinationScanned
      ? sourceWorkStationId
      : sourcePod || sourceTrayNumber;

    scannedData = {
      barcode,
      destinationIsCommonStation,
      destinationPod,
      destinationWorkStationId,
      destinationWorkStationName,
      destinationZone,
      inventoryTransferId,
      isDestinationScanned,
      isPod: !isTray,
      packagesCount: totalInventories,
      sourcePod,
      sourceTrayId,
      sourceTrayNumber,
      sourceZone,
      title,
      traysCount: sourceTrayNumber ? undefined : noOfTrays,
      transferStatus: inventoryTransferStatus as string,
      workStationId: destinationWorkStationId,
      workStationProcessId: sourceWorkStationId,
      workStationZoneType: destinationPod,
    };
  }

  return {
    ...data,
    formattedTrays,
    scannedDetails: scannedData || undefined,
  };
}
